import angular from 'angular';

angular.module('cloudX').directive('cxConfigSubSection', [
  function() {
    return {
      restrict: 'E',
      template: require('./configSubSection.html'),
      replace: true,
      scope: {
        section: '=',
        fields: '=',
        configs: '=',
      },
      controller: 'ConfigSectionCtrl',
    };
  },
]);
